// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2ja_v","container":"Modal_container__GJxZ8","header":"Modal_header__ob6ip","body":"Modal_body__2Ie7O"};